import React, { FC, useMemo } from 'react';
import { Form } from '@ant-design/compatible';
import ExpenseCategoryInput from '../expense_category_input/ExpenseCategoryInput';
import { connect } from 'react-redux';
import { getBuyerCompanySettingValue } from '../../utils/AuthUtils';

const CATEGORY_CONFIG = {
	capex: {
		configPath: 'capExConfig.acceptCapExCategory',
		label: 'CapEx Category',
		fieldDecoratorName: 'capExCategoryInput',
		categoryIdField: 'capExCategoryId',
		categoryField: 'capExCategory',
		showWhenCapex: true,
	},
	rm: {
		configPath: 'rmConfig.acceptRmCategory',
		label: 'R&M Category',
		fieldDecoratorName: 'rmCategoryInput',
		categoryIdField: 'rmCategoryId',
		categoryField: 'rmCategory',
		showWhenCapex: false,
	},
};

interface ExpenseCategoryFormFieldProps {
	categoryType: 'capex' | 'rm';
	isCapex: boolean;
	getFieldDecorator: any;
	formData: any;
	companyConfig?: any;
	userType?: any;
	currentUser?: any;
}

const ExpenseCategoryFormField: FC<ExpenseCategoryFormFieldProps> = ({
	categoryType,
	isCapex,
	getFieldDecorator,
	formData,
	companyConfig,
	userType,
	currentUser,
}): React.ReactElement => {
	const config = CATEGORY_CONFIG[categoryType];

	const allowCategory = useMemo(
		() => getBuyerCompanySettingValue(userType)(config.configPath, companyConfig, currentUser),
		[companyConfig, currentUser, userType, config.configPath]
	);

	const shouldShow = config.showWhenCapex ? isCapex : !isCapex;

	return allowCategory && shouldShow ? (
		<Form.Item label={config.label}>
			{getFieldDecorator(config.fieldDecoratorName, {
				initialValue: {
					[config.categoryIdField]: formData[config.categoryIdField],
					[config.categoryField]: formData[config.categoryField],
				},
			})(<ExpenseCategoryInput categoryType={categoryType} />)}
		</Form.Item>
	) : null;
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
	userType: state.session.userType,
});

// `pure: false` is required: this field is decorated with the legacy `getFieldDecorator`,
// which only refreshes the controlled input's `value` when this component re-renders. The
// parent `Form.create` form re-renders on every keystroke, but its props to us don't change
// and the redux store doesn't either — a pure `connect` would short-circuit that re-render and
// leave the Select/Input frozen (typing/clearing appear to do nothing). See OPE-5067.
export default connect(mapStateToProps, null, null, { pure: false })(ExpenseCategoryFormField);
